import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Icon from "@insite/mobius/Icon";
import Link from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import CustomTriangleExclamation from "@WhiteCap/Icons/CustomTriangleExclamation";

import React from "react";
import { css } from "styled-components";

const enum fields {
    title = "title",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.title]: string;
    };
}

export interface ComplianceRestrictionsStyle {
    title?: InjectableCss;
    complianceContainer?: InjectableCss;
    mainContainer?: InjectableCss;
    link?: InjectableCss;
    warning?: InjectableCss;
    warningMessage?: InjectableCss;
}
export const complianceRestrictionsStyle: ComplianceRestrictionsStyle = {
    complianceContainer: {
        css: css`
            display: flex;
            column-gap: 10px;
            svg {
                fill: #ffcc33;
                height: 20px !important;
                width: 20px !important;
                margin-top: 10px;
            }
        `,
    },
    mainContainer: {
        css: css`
            width: 50%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 100%;
                    `,
                    css`
                        width: 100%;
                    `,
                    css`
                        width: 100%;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    title: {
        css: css`
            font-weight: 600;
            color: #474747;
            font-size: 24px;
            text-transform: uppercase;
            margin-bottom: 10px;
        `,
    },
    link: {
        css: css`
            color: #005eaa;
            text-decoration: underline;
            font-size: 18px;
        `,
    },
    warning: {
        css: css`
            font-size: 18px;
            font-weight: 700;
            color: #005eaa;
        `,
    },
    warningMessage: {
        css: css`
            color: #000;
            font-size: 18px;
        `,
    },
};
const styles = complianceRestrictionsStyle;

type Props = OwnProps & HasProduct;

const ComplianceRestrictions: React.FC<Props> = ({ product, fields }) => {
    if (!product || !product.properties || typeof product.properties.erP_CA_PROP_65 !== "string") {
        return null;
    }

    return (
        <>
            {product.properties.erP_CA_PROP_65.toLocaleLowerCase() === "true" ? (
                <StyledWrapper {...styles.mainContainer}>
                    <StyledWrapper {...styles.title}>
                        {fields.title ? fields.title : "COMPLIANCE AND RESTRICTIONS"}
                    </StyledWrapper>
                    <StyledWrapper {...styles.complianceContainer}>
                        <Icon src={CustomTriangleExclamation}></Icon>
                        <StyledWrapper>
                            <Typography {...styles.warning}>Warning: California Prop 65 - </Typography>
                            &nbsp;
                            <Typography {...styles.warningMessage}>
                                {product.properties.ecoM_CA_PROP65_MESSAGE}
                            </Typography>
                            &nbsp;
                            <Link href="http://www.P65Warnings.ca.gov" {...styles.link} target="_Blank">
                                {translate(" www.P65Warnings.ca.gov")}
                            </Link>
                        </StyledWrapper>
                    </StyledWrapper>
                </StyledWrapper>
            ) : null}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ComplianceRestrictions),
    definition: {
        group: "Common",
        displayName: "ComplianceRestrictions",
        fieldDefinitions: [
            {
                name: fields.title,
                displayName: "Title ",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "General",
                sortOrder: 0,
            },
        ],
    },
};

export default widgetModule;
